<template>
  <div class="article">
    <div class="main">
      <van-tabs
        v-model="active"
        border
        color="#31D5BF"
        title-active-color="#101010"
        line-width="71px"
        @click="gettab"
      >
        <van-tab title="精品爆文"></van-tab>
        <van-tab title="我的爆文"></van-tab>
      </van-tabs>
      <van-divider style="margin: 0 12px" />
      <div class="group" v-if="active == 0">
        <div class="flex ml-10" style="overflow-x: auto; height: 100px">
          <div
            v-for="(item, index) in btnlist"
            :key="index"
            class="btn"
            :class="{ btn_active: index == checked }"
            @click="checkbtn(index, item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>

      <van-list
        v-model="listLoading"
        :finished="isfinished"
        :finished-text="list.length > 0 ? '没有更多了' : '暂无文章'"
        @load="getmore"
        :offset="300"
      >
        <van-empty description="" v-if="list.length == 0" />
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="todetail(item)"
          v-else
        >
          <div class="list flex jc-sb mt-20">
            <div>
              <div class="title van-multi-ellipsis--l2">
                {{ item.title }}
              </div>
              <div class="flex aic jc-sb mt12">
                <div class="typebtn">{{ item.categoryName }}</div>
                <div style="color: #999fa4" class="f12 flex aic">
                  <van-icon name="browsing-history" />
                  <span class="ml-5">{{ item.times }}</span>
                </div>
              </div>
            </div>
            <div class="rel posterimg">
              <img :src="item.coverImgUrl" class="posterimg" />
              <img
                src="../../assets/img/card/istop.png"
                v-if="item.isTop"
                class="istop"
              />
            </div>
          </div>
          <van-divider style="margin: 24px 12px 0" />
        </div>
      </van-list>
      <!-- <div class="bottom1" @click="getmore" v-if="!isfinished">
        加载更多
        <img
          src="../../assets/img/card/down.svg"
          class="down"
          style="width: 15px; height: 15px"
        />
      </div>
      <div class="bottom1" v-else>已经到底了</div> -->
    </div>
  </div>
</template>
<script>
import {
  articleCategory,
  article,
  userArticle,
  articledetail,
} from "@/api/article";
import {setyoumeng} from '../../utils/index'
export default {
  data() {
    return {
      btnlist: [{ name: "推荐", id: "" }],
      checked: 0,
      active: 0,
      list: [],
      page: 0,
      categoryId: "",
      isfinished: false,
      userid: "",
      listLoading: false,
      iscan:false
    };
  },
  methods: {
    // 分类选择
    checkbtn(inx, itm) {
      this.categoryId = itm.id;
      this.checked = inx;
      this.list = [];
      this.page = 0;
      this.isfinished = false;
      this.getarticle();
    },
    // 获取分类
    getarticleCategory() {
      let data = {
        page: 0,
        size: 99,
        sort: "id,desc",
        enabled: true,
      };
      articleCategory(data).then((res) => {
        this.btnlist = this.btnlist.concat(res.content);
      });
    },
    // 文章列表
    getarticle() {
      if (this.isfinished) {
        return;
      }
      if(this.iscan){
        return
      }
      this.iscan=true
      if (this.active == 0) {
        const sort = ["isTop,desc", "id,desc"];
        let data = {
          categoryId: this.categoryId,
          enabled: true,
          sort,
          page: this.page,
          size: 10,
          sort: ["isTop,desc", "id,desc"],
        };
        article(data).then((res) => {
          if (res.content.length > 0) {
            if(this.page==0)this.list=[]
            this.page++;
            this.list = this.list.concat(res.content);
            this.listLoading = false;
            this.iscan = false;
          } else {
            this.listLoading = false;
            this.isfinished = true;
            this.iscan = false;
          }
        });
      } else {
        let data = {
          categoryId: this.categoryId,
          page: this.page,
          size: 10,
        };
        data.userId = this.userid;
        userArticle(data).then((res) => {
          if (res.content.length > 0) {
            if(this.page==0)this.list=[]
            this.page++;
            res.content.map((item) => this.getdetail(item));
            this.listLoading = false;
            this.iscan = false;
          } else {
            this.isfinished = true;
            this.listLoading = false;
            this.iscan = false;
          }
        });
      }
    },
    // 加载更多
    getmore() {
      this.getarticle();
    },
    //
    gettab(name, title) {
      this.list = [];
      this.page = 0;
      this.isfinished = false;
      this.getarticle();
    },
    todetail(itm) {
      console.log(itm);
      this.$router.push({
        path: "/articledetail",
        query: { userId: this.userid, articleId: itm.id },
      });
    },
    getinfo() {
      userinfo().then((res) => {
        this.userid = res.id;
        if (!this.$store.state.user.user.user) {
          this.$store.commit("SET_USER", { user: res });
        }
        console.log(this.$store.state.user.user);
      });
    },
    getdetail(id) {
      articledetail(id.articleId).then((res) => {
        this.list.push(res);
      });
    },
  },
  mounted() {
    setyoumeng("https://s9.cnzz.com/z_stat.php?id=1279766178&web_id=1279766178")
    this.getarticleCategory();
    // this.getarticle();
    if (!this.$store.state.user.user.user) {
      this.getinfo();
    } else {
      this.userid = this.$store.state.user.user.user.id;
    }
  },
};
</script>
<style lang="less" >
.article {
  width: 100%;
  .van-tab {
    font-size: 15px !important;
  }
  .van-tab--active {
    font-size: 18px !important;
  }
  .main {
    width: 358px;
    // height: 800px;
    font-family: Roboto;
    border: 1px solid rgba(255, 255, 255, 100);
    border-radius: 4px;
    margin: 20px auto;
    background: #fff;
    .group {
      width: 350px;
      overflow: hidden;
      height: 38px;
    }
    .btn {
      width: 70px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 100);
      color: rgba(49, 73, 91, 100);
      font-size: 13px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(237, 241, 245, 100);
      margin-right: 10px;
      margin-top: 8px;
      flex-shrink: 0;
    }
    .btn_active {
      background-color: rgba(93, 199, 185, 100) !important;
      color: rgba(246, 245, 245, 100) !important;
    }
    .list {
      margin-left: 10px;
      margin-right: 11px;
      .posterimg {
        width: 112px;
        height: 79px;
        border-radius: 8px;
      }
      .istop {
        width: 55px;
        height: 55px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .title {
        width: 204px;
        height: 46px;
        color: rgba(16, 16, 16, 100);
        line-height: 23px;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        overflow: hidden;
      }
      .typebtn {
        width: 51px;
        height: 18px;
        line-height: 18px;
        border-radius: 9px;
        color: rgba(93, 199, 185, 100);
        font-size: 9px;
        text-align: center;
        font-family: Roboto;
        border: 1px solid rgba(93, 199, 185, 100);
      }
      .mt12 {
        margin-top: 12px;
      }
    }
    .bottom1 {
      width: 100%;
      height: 56px;
      line-height: 56px;
      color: rgba(16, 16, 16, 100);
      font-size: 15px;
      text-align: center;
      font-family: SourceHanSansSC-regular;
    }
    .down {
      width: 15px !important;
      height: 15px !important;
    }
  }
}
</style>